<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout row wrap justify-end> </v-layout>
        <v-layout row wrap pa-2>
          <!-- <v-flex lg3 md3 sm12>
            <v-autocomplete
              label="Đầu bao"
              class="input-group--focused"
              :items="prefixBigpackages"
              item-text="name"
              item-value="value"
              v-model="currentItem.PrefixBigpackage"
              :disabled="currentItem.ID > 0"
            ></v-autocomplete>
          </v-flex> -->
          <v-flex lg3 md3 sm12>
            <v-text-field
              label="Biển số xe"
              class="input-group--focused"
              outlined
              dense
              v-model="currentItem.LicensePlate"
            ></v-text-field>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-text-field
              label="Biển số xe (VN)"
              class="input-group--focused"
              outlined
              dense
              v-model="currentItem.LicensePlateVN"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex lg3 md3 sm12>
            <v-select
              label="Người gọi xe"
              class="input-group--focused"
              v-model="currentItem.Caller"
              :items="truck_caller"
              item-text="name"
              item-value="value"
              outlined
              dense
              clearable
            ></v-select>
          </v-flex> -->
          <v-flex lg6 md6 sm12></v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker
              plabel="Ngày xếp xe"
              class="input-group--focused date-picker"
              v-model="orderDate"
              @onChangeDate="orderDate = $event"
            ></mh-date-picker>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker
              plabel="Ngày chuyển xe"
              class="input-group--focused date-picker"
              v-model="tranferDate"
              @onChangeDate="tranferDate = $event"
            ></mh-date-picker>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker
              plabel="Ngày xếp xe"
              class="input-group--focused date-picker"
              v-model="releaseDate"
              @onChangeDate="releaseDate = $event"
            ></mh-date-picker>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker
              plabel="Ngày nhập kho"
              class="input-group--focused date-picker"
              v-model="storeDate"
              @onChangeDate="storeDate = $event"
            ></mh-date-picker>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-2>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng cân"
              v-model="currentItem.Weight"
              :decimal="1"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng khối"
              v-model="currentItem.Volume"
              :decimal="2"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng mã"
              v-model="currentItem.NumberOfProduct"
              :decimal="0"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-select
              label="Trạng thái"
              v-model="currentItem.Status"
              :items="receive_type_list"
              item-text="name"
              item-value="value"
              class="input-group--focused"
              outlined
              dense
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-2>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng kiện"
              :value="totalNumberOfPack"
              :decimal="0"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng kiện nhận"
              :value="importedNumberOfPack"
              :decimal="0"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng chi không thuế"
              v-model="currentItem.WeightCost"
              :decimal="0"
              class="input-group--focused"
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng thuế"
              v-model="currentItem.TaxCost"
              :decimal="0"
              class="input-group--focused"
            ></h-currency-input>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-6>
          <v-flex lg12 md12 sm12>
            <v-layout row wrap justify-space-between pr-1>
              <v-flex lg4 md4 sm12>
                <v-text-field
                  v-model="scanCode"
                  label="Quét mã kiện/bao nhập kho"
                  outlined
                  dense
                  hide-details
                  @keyup.enter="scanImport"
                  append-icon="mdi-barcode-scan"
                  :disabled="!currentItem.ID || currentItem.Status != receive_type.cho_thong_quan_vn"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm12 class="text-right">
                <v-btn
                  class="mx-2 white--text"
                  color="blue"
                  @click="saveAllProduct()"
                  :disabled="!currentItem.ID || currentItem.Status != receive_type.cho_thong_quan_vn"
                  >Nhập tất cả (Xác nhận cả xe)</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg12>
            <v-data-table
              :headers="detail_header"
              :items="details"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td class="text-center">{{ index + 1 }}</td>
                  <td>{{ item.UserName }}</td>
                  <td>{{ (item.IsPackage || item.GoodsType == 1) ? '' : item.PartnerName }}</td>
                  <td>{{ item.IsPackage ? 'Bao hàng TN' : (item.GoodsType == 1 ? '' : item.ProductNameCN) }}</td>
                  <!-- <td>{{ item.ProductNameVN }}</td> -->
                  <td>{{ item.SuffixBill }}</td>
                  <td class="text-right">
                    {{ item.Deposit | currency("", 2) }}
                  </td>
                  <!-- <td class="text-right">{{ item.ExchangeRate | currency }}</td> -->
                  <td class="text-right">
                    {{ item.Weight | currency("", 1) }}
                  </td>
                  <td class="text-right">
                    {{ item.Volume | currency("", 3) }}
                  </td>
                  <td class="text-right">
                    {{ item.OrderNumberOfPack | currency }}
                  </td>
                  <td>
                    <v-chip :color="isImportedItem(item) ? 'green' : 'grey'" text-color="white" small>
                      {{ isImportedItem(item) ? 'Đã nhập kho' : 'Chưa nhập kho' }}
                    </v-chip>
                  </td>
                  <td class="text-center">
                    <v-btn small color="blue" class="white--text" @click="scanCode = item.SuffixBill; scanImport()" :disabled="isImportedItem(item)">Xác nhận</v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>
<script>
// import Filtering from "@/components/Filtering";
import MHDatePicker from "@/components/daterange/MHDatePicker";
import { mapState } from "vuex";
import configs from "@/configs";
import moment from "moment";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";
import _ from "lodash";
export default {
  components: {
    // "hpo-filter": Filtering,
    "mh-date-picker": MHDatePicker,
  },
  data() {
    return {
      orderDate: null,
      storeDate: null,
      releaseDate: null,
      tranferDate: null,
      product_status: configs.PRODUCT_STATUS,
      bigpackage_status_type: configs.BIGPACKAGE_STATUS_TYPE,
      product_status_list: configs.PRODUCT_STATUS_LIST,
      receive_type_list: configs.RECEIVE_TYPE_LIST,
      receive_type: configs.RECEIVE_TYPE,
      truck_caller: configs.TRUCK_CALLER,
      scanCode: '',
      detail_header: [
        {
          text: "STT",
          value: "stt",
          align: "center",
          width: "70px",
          sortable: false,
        },
        {
          text: "Mã KH",
          value: "UserName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên đối tác",
          value: "PartnerName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên hàng TQ",
          value: "ProductNameCN",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        // {
        //   text: "Tên hàng VN",
        //   value: "ProductNameVN",
        //   filterable: true,
        //   dataType: configs.DATA_TYPE["String"],
        // },
        {
          text: "Mã vận đơn",
          value: "SuffixBill",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tổng chi (¥)",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        // {
        //   text: "Tỷ giá",
        //   value: "ExchangeRate",
        //   align: "end",
        //   filterable: true,
        //   dataType: configs.DATA_TYPE["Number"],
        // },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "OrderNumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.RECEIVE_TYPE_LIST,
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "",
          value: "",
          align: "center",
          width: "80px",
        },
      ],
      pagination: { ...configs.PAGINATION },
      items_per_page: { ...configs.ITEMS_PER_PAGE },
      filterConditions: [],
      quickFilterConditions: [],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.order.loading,
      currentItem: state => state.order.selected,
      configuration: state => state.configuration.selected,
      details: state => state.product.orderList.data,
      total_details: state => state.product.orderList.total,
      popup_items: state => state.product.all.data,
      packages_not_transit: (state) => state.bigPackage.notTransit,
      product_types: state => state.productType.all.data,
    }),
    prefixBigpackages() {
      if (this.configuration && this.configuration.PrefixBigpackages) {
        const prefixs = JSON.parse(this.configuration.PrefixBigpackages);
        if (prefixs.length) {
          return prefixs.map((a) => {
            return { value: a, name: a };
          });
        }
      }
      return [];
    },
    currentId() {
      return Number(this.$route.params.Pid);
    },
    totalNumberOfPack() {
      return Number(this.currentItem.NumberOfPack || 0);
    },
    importedNumberOfPack() {
      return _.sumBy(this.details || [], (item) => {
        return this.isImportedItem(item) ? Number(item.OrderNumberOfPack || 0) : 0;
      });
    }
  }, 
  watch: {
    currentItem() {
      this.orderDate = this.currentItem.OrderDate
        ? moment.utc(this.currentItem.OrderDate).format('YYYY-MM-DD')
        : null;
      this.storeDate = this.currentItem.StoreDate
        ? moment.utc(this.currentItem.StoreDate).format('YYYY-MM-DD')
        : null;
      this.tranferDate = this.currentItem.TranferDate
        ? moment.utc(this.currentItem.TranferDate).format('YYYY-MM-DD')
        : null;
      this.releaseDate = this.currentItem.ReleaseTruckDate
        ? moment.utc(this.currentItem.ReleaseTruckDate).format('YYYY-MM-DD')
        : null;
    },
    product_types() {
        let header_item = _.find(this.popup_header, { value: "ProductType" });
        if (header_item) {
            header_item.values =
                _.map(this.product_types, (item) => {
                    return {
                        value: item.ID,
                        name: item.Name,
                    };
                }) || [];
        }
    }
  },
  methods: {
    isImportedItem(item) {
      return item.Status == this.product_status.nhap_kho_vn || item.Status == this.product_status.xuat_thieu || item.Status == this.product_status.xuat_du || (item.IsPackage && item.Status == this.bigpackage_status_type.NhapKhoVN);
    },
    scanImport() {
      if (!this.scanCode) return;
      let codeToScan = this.scanCode.trim().toLowerCase();
      let item = this.details.find(d => d.SuffixBill && d.SuffixBill.trim().toLowerCase() === codeToScan);
      if (item) {
        if (this.isImportedItem(item)) {
          sendErrorNotice("Mã này đã được nhập kho VN rồi.");
          this.scanCode = '';
          return;
        }
        if (item.IsPackage) {
           this.$store.dispatch("bigPackage/setDetail", {
              data: { Status: this.bigpackage_status_type.NhapKhoVN },
              id: item.ID
           });
        } else {
           this.$store.dispatch("product/setDetail", {
              data: { Status: this.product_status.nhap_kho_vn },
              id: item.ID
           });
        }
        this.scanCode = '';
      } else {
        sendErrorNotice("Không tìm thấy mã này trong xe.");
        this.scanCode = '';
      }
    },
    getDetail() {
      if (!this.currentId) {
        this.$store.commit("order/setDetail", { ID: 0, Status: this.receive_type.cho_xep_xe });
      } else {
        this.$store.dispatch("order/getDetail", this.currentId).then((ret) => {
          ret = ret.data ? ret.data : ret;
          if (_.isEmpty(ret)) {
            sendErrorNotice("Lỗi, không load được dữ liệu.");
          }
        });
        this.$store.dispatch("product/getOrderList", this.currentId);
      }
    },
    saveData() {
      this.$store.dispatch("order/setDetail", {
        'data': {
          ...this.currentItem, 
          OrderDate: this.orderDate ? moment.utc(this.orderDate).format(configs.SQL_DATE_FORMAT) : null, 
          StoreDate: this.storeDate ? moment.utc(this.storeDate).format(configs.SQL_DATE_FORMAT) : null,
          TranferDate: this.tranferDate ? moment.utc(this.tranferDate).format(configs.SQL_DATE_FORMAT) : null,
          ReleaseTruckDate: this.releaseDate ? moment.utc(this.releaseDate).format(configs.SQL_DATE_FORMAT) : null,
        },
        'id': this.currentItem.ID
      });
      if(!this.currentItem.ID) {
        window.getApp.$emit("APP_NAVIGATE", "TruckList");
      }
    },
    saveOrderProduct(item) {
      this.$store.dispatch("orderProduct/setDetail", {
        'data': {
          ...item
        },
        'id': 99999999
      });
    },
    saveProductItem(item) {
      this.$store.dispatch("product/setDetail", {
        'data': {
          ...item,
          Status: item.ReceiveStatus == this.receive_type.nhap_kho_vn ? this.product_status.nhap_kho_vn : this.product_status.xep_xe
        },
        'id': item.ID
      });
    },
    saveAllProduct() {
      this.$store.dispatch("order/setDetail", {
        'data': {
          ActionType: 'update_child',
          Status: this.product_status.nhap_kho_vn,
          ReceiveStatus: this.receive_type.nhap_kho_vn
        },
        'id': this.currentItem.ID
      });
    },
    exportData() {
      this.$store.dispatch("order/exportDetail", this.currentItem.ID);
    }
  },
  mounted() {
    this.$store.dispatch("configuration/getDetail", 1);
    this.$store.dispatch("productType/getList");
    this.getDetail();
    this.$root.$on("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$on("REQUEST_CREATE_DATA", this.exportData);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$off("REQUEST_CREATE_DATA", this.exportData);
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
  },
};
</script>
